import PropertyScrollspyContainer from "../../../../components/property/detail/PropertyScrollspy";

const PropertyScrollspy = () => {
  return <PropertyScrollspyContainer />;
};

export default PropertyScrollspy;
